export interface ThreadData {
  id: string;
  title: string;
  preview?: string;
  timestamp?: string;
  uuid: string;
}

export const getThreadTitle = (threads, id: null | string): string => {
  if (!id) return "New thread";
  const thread = threads.find((t) => t.uuid === id);
  return thread ? thread.title || 'Unnamed thread' : `Thread`;
};
